import { FormNumericInput } from 'components/form-fields';
import { useValidation } from 'hooks/useValidation';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import classNames from 'classnames';

export function OcrIntegerLayout(props) {
    const [_, errors, validate] = useValidation();

    useEffect(() => {
        validateLayout();
    }, [props.layout.answer]);

    function validateLayout() {
        const required = props.layout.requiredAnswerCount > 0;
        const rules = [{ fieldName: 'answer', required: required }];
        validate(rules, props.layout);
    }

    function onValueChange(value) {
        const clonedLayout = { ...props.layout };

        clonedLayout.answer = value;

        props.onChange(clonedLayout);
    }

    return <Fragment>
        <div className={classNames("form-field", { "hide-in-print": !props.readonly, "hidden": props.readonly })}>
            <FormNumericInput
                loading={props.loading}
                disabled={props.disabled}
                onValueChange={onValueChange}
                selectedValue={props.layout.answer ? props.layout.answer : ''}
                headingText={props.layout.secondaryLayoutTitle}
                dangerHelperText={errors.answer}
                allowDecimal={false}
            />
        </div>
        <p className={classNames({ "show-in-print": !props.readonly, "visible": props.readonly, "bp3-skeleton": props.loading  })}>{props.layout.answer}</p>
    </Fragment>;
}

OcrIntegerLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};

OcrIntegerLayout.defaultProps = {
    loading: false,
    disabled: false,
    readonly: false
};
